<template>
  <page-section
    id="upcoming-elections"
    :title="$t('cac.app.upcoming_elections')"
    class="voter-info__page-section"
  >
    <div class="row justify-content-between">
      <ol class="upcoming-elections-list col-md-10">
        <li
          v-for="election in elections"
          :key="election.name"
        >
          {{ election.fullDate }} - {{ election.name }}
        </li>
      </ol>
      <div class="upcoming-elections-button__wrapper col col-md-7 col-lg-6">
        <calendar-button 
          v-if="lastElectionName && lastElectionName.length > 0" 
          :election-name="lastElectionName"/>
      </div>
    </div>
  </page-section>
</template>

<script>
import PageSection from "CivicActionCenterComponents/shared/PageSection.vue";
import CalendarButton from "CivicActionCenterComponents/sections/VoterInformation/UpcomingElections/CalendarButton.vue";

export default {
  name: "UpcomingElections",
  components: {
    PageSection,
    CalendarButton
  },
  props: {
    elections: {
      type: Array,
      required: true
    }
  },
  computed: {
    lastElectionName() {
      if (this.elections && this.elections.length > 0) {
        return this.elections[this.elections.length - 1].name || "";
      }
      return "";
    }
  }
};
</script>
